import {
  DistributionStage,
  OfferStage,
  QueueExclusionReason,
} from '../api/enumerations';

/** Copy shared by every screen that shows the queue distribution (REAL-3271). */
export const Constants = {
  stage: {
    [DistributionStage.QUEUED]: 'Na fila',
    [DistributionStage.OFFERING_REGULAR]: 'Em oferta',
    [DistributionStage.OFFERING_OVERFLOW]: 'Em oferta (transbordo)',
    [DistributionStage.ASSIGNED]: 'Atribuída pela fila',
    [DistributionStage.MANUAL_REQUIRED]: 'Atribuição manual',
  } as Record<DistributionStage, string>,
  offerStage: {
    [OfferStage.REGULAR]: 'rodada regular',
    [OfferStage.OVERFLOW]: 'transbordo',
  } as Record<OfferStage, string>,
  manualRequiredHint: 'Nenhuma credenciada aceitou a oferta',
  offeredTo: (company: string): string => `Ofertada para ${company}`,
  assignedTo: (company: string): string => `Aceita por ${company}`,
  assignManually: 'Atribuir manualmente',
  pullFromQueue: {
    trigger: 'Retirar da fila',
    title: 'Retirar esta OS da fila?',
    text:
      'A oferta atual é cancelada e a OS passa para atribuição manual. ' +
      'A credenciada não perde a posição na fila.',
    cancel: 'Cancelar',
    confirm: 'Retirar da fila',
    success: 'OS retirada da fila. Ela agora aguarda atribuição manual.',
  },
  liftQueueBan: {
    trigger: 'Retirar suspensão',
    title: 'Retirar a suspensão da fila?',
    text: (company: string): string =>
      `${company} volta a ser candidata nas próximas ofertas deste edital. ` +
      'A posição na fila não muda.',
    cancel: 'Cancelar',
    confirm: 'Retirar suspensão',
    success: 'Suspensão retirada',
  },
  round: (round: number, stage: string): string =>
    `${round}ª oferta · ${stage}`,
  expired: 'oferta expirada',
  expiresIn: (left: string): string => `expira em ${left}`,
  expiresAt: (date: string): string => `expira ${date}`,
  exclusion: {
    [QueueExclusionReason.BANNED]: 'suspensa por baixa taxa de aceite',
    [QueueExclusionReason.SCORE]: 'score baixo',
    [QueueExclusionReason.PUNCTUALITY]: 'pontualidade baixa',
  } as Record<QueueExclusionReason, string>,
  bannedUntil: (date: string): string => `até ${date}`,
};
